/** @jsx jsx */
import { jsx, css } from "@emotion/core";
import Output from "./Output";
import ClassOneBg from "../Image/classOne.jpg";
import ClassTwoBg from "../Image/classTwo.jpg";
import ClassThreeBg from "../Image/classThree.jpg";
import ClassFourBg from "../Image/classFour.jpg";
import ClassFiveBg from "../Image/classFive.jpg";
const Results = ({ tour }) => (
  <div css={styles} className="results" >
    {tour === "FirstClass" && (
      <Output
        title="FRONT VIEW"
        img={ClassOneBg}
      />
    )}
    {tour  === "SecondClass" && (
      <Output
        title="PARKING AREA"
        img={ClassTwoBg}
      />
    )}
    {tour  === "ThirdClass" && (
      <Output
        title="ROOM VIEW"
        img={ClassThreeBg}
      />
    )}
    {tour  === "FourthClass" && (
      <Output
        title="WASHROOM VIEW"
        img={ClassFourBg}
      />
    )}

    {tour  === "FifthClass" && (
      <Output
        title="OTHER AMINITIES"
        img={ClassFiveBg}
      />
    )}
  </div>
);

const styles = css`
  width: 100%;
  max-width: 80%;
  .test {
    width: 100%;
    height: 400px;
    background: red;
    &.two {
      background: blue;
    }
  }
  @media(max-width: 900px){
    max-width: 510px;
    padding: 30px 0 0 0;
  }
  @media (min-width: 901px) and (max-width: 1226px){
    max-width: 62%;
  }
`;

export default Results;
